import { Box } from '@chakra-ui/react';
import { Outlet, useLocation } from 'react-router-dom';
import FooterSales from './components/FooterSales';
import HeaderSales from './components/HeaderSales';

export default function OnlineSalesLayoutPage() {
    const location = useLocation();

    const path = location.pathname.split('/');

    const lastPath = path[path.length - 1];
    const blacklistPath = ['outlet', 'brand'];
    const isBlackListPath = blacklistPath.includes(lastPath);

    return (
        <Box w='full' minH='100vh' bg='gray.50' position='relative' overflowY='scroll' style={{ scrollbarWidth: 'none' }} p={isBlackListPath ? 0 : 3}>
            {isBlackListPath || <HeaderSales />}
            <Outlet />
            {isBlackListPath || <FooterSales />}
            <Box mb={12} />
        </Box>
    );

    // return (
    //     <NavigationScroll>
    //         <Box w='full' minH='100vh' bg='gray.50' position='relative' overflowY='scroll' style={{ scrollbarWidth: 'none' }} p={isBlackListPath ? 0 : 3}>
    //             {isBlackListPath || <HeaderSales />}
    //             <Outlet />
    //             {isBlackListPath || <FooterSales />}
    //             <Box mb={12} />
    //         </Box>

    //         {/* <Box w={{ base: '60px', md: '65px' }} h={{ base: '60px', md: '65px' }} bg='primary.600' rounded='full' boxShadow='0 0 20px 1px rgba(0, 0, 0, 0.2)' position='fixed' bottom={4} right={4} zIndex={999} cursor='pointer' onClick={() => navigate('/')}>
    //             <Center w='full' h='full'>
    //                 <Icon as={BiHome} w={6} h={6} color='white' />
    //             </Center>
    //         </Box> */}
    //     </NavigationScroll>
    // );
}
